// extracted by mini-css-extract-plugin
export default {"option":"HealthMailContactOption_option__WfSnx","name":"HealthMailContactOption_name__LaqVg","location":"HealthMailContactOption_location__flpyu"};